import React, { FC, useState, useEffect } from 'react'

import { HeaderWrapper } from './header.styles';

interface HeaderProps {
  images?: string[];
}

export const Header: FC<HeaderProps> = ({ images }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  // Default images if none provided
  const defaultImages = [
    'https://imagedelivery.net/Z5lEYwq8x5HYlOcAYUT42Q/2f30b6c6-35da-4942-eda4-4892cd183e00/public'
  ];

  const imageList = images && images.length > 0 ? images : defaultImages;

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      const documentHeight = document.documentElement.scrollHeight - window.innerHeight;
      const numberOfImages = imageList.length;

      // Calculate the scroll position that triggers each image change
      // Formula: changePoint = (totalHeight / numberOfImages) * imageIndex
      const changePointHeight = documentHeight / numberOfImages;

      // Determine which image should be shown based on scroll position
      const newIndex = Math.min(
        Math.floor(scrollY / changePointHeight),
        numberOfImages - 1
      );

      setCurrentImageIndex(newIndex);
    };

    // Add scroll event listener
    window.addEventListener('scroll', handleScroll);

    // Initial calculation
    handleScroll();

    // Cleanup
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [imageList.length]);

  return (
    <HeaderWrapper>
      <div
        className="page-header min-vh-100"
        style={{
          backgroundImage: `url('${imageList[currentImageIndex]}')`,
          backgroundSize: 'cover',
          backgroundRepeat: 'no-repeat',
          backgroundPositionX: 'center',
          backgroundPositionY: '-50px',
          transition: 'background-image 0.5s ease-in-out',
        }}>
      </div>
    </HeaderWrapper>
  );
}
